import { Node, mergeAttributes } from '@tiptap/core';

/**
 * Custom TipTap extension for email button blocks
 * Validates: Requirements 18.1-18.5
 */
export const ButtonBlock = Node.create({
  name: 'emailButton',
  
  group: 'block',
  
  content: 'inline*',
  
  addAttributes() {
    return {
      href: {
        default: '#',
        parseHTML: element => element.getAttribute('href'),
        renderHTML: attributes => {
          return {
            href: attributes.href,
          };
        },
      },
      buttonText: {
        default: 'Click Here',
        parseHTML: element => element.textContent,
        renderHTML: attributes => {
          return {};
        },
      },
    };
  },
  
  parseHTML() {
    return [
      {
        tag: 'a.email-button',
      },
    ];
  },
  
  renderHTML({ node, HTMLAttributes }) {
    return [
      'div',
      { class: 'email-button-wrapper', style: 'text-align: center; margin: 20px 0;' },
      [
        'a',
        mergeAttributes(HTMLAttributes, {
          class: 'email-button',
          href: node.attrs.href,
          style: 'display: inline-block; padding: 12px 24px; background-color: #1976d2; color: #ffffff; text-decoration: none; border-radius: 4px; font-weight: 500;',
        }),
        node.attrs.buttonText,
      ],
    ];
  },
  
  addCommands() {
    return {
      insertButton: (attributes) => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: attributes,
        });
      },
    };
  },
});

/**
 * Custom TipTap extension for preheader text
 * Preheader text appears in email client previews but is hidden in the email body
 * Validates: Requirements 18.1-18.5
 */
export const PreheaderBlock = Node.create({
  name: 'preheader',
  
  group: 'block',
  
  content: 'text*',
  
  addAttributes() {
    return {
      text: {
        default: '',
        parseHTML: element => element.textContent,
        renderHTML: attributes => {
          return {};
        },
      },
    };
  },
  
  parseHTML() {
    return [
      {
        tag: 'div.preheader',
      },
    ];
  },
  
  renderHTML({ node, HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        class: 'preheader',
        style: 'display: none; max-height: 0; overflow: hidden; mso-hide: all;',
      }),
      node.attrs.text,
    ];
  },
  
  addCommands() {
    return {
      insertPreheader: (attributes) => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: attributes,
        });
      },
    };
  },
});

/**
 * Custom TipTap extension for horizontal dividers
 * Validates: Requirements 18.1-18.5
 */
export const DividerBlock = Node.create({
  name: 'divider',
  
  group: 'block',
  
  parseHTML() {
    return [
      {
        tag: 'hr.email-divider',
      },
    ];
  },
  
  renderHTML({ HTMLAttributes }) {
    return [
      'hr',
      mergeAttributes(HTMLAttributes, {
        class: 'email-divider',
        style: 'border: none; border-top: 2px solid #e0e0e0; margin: 20px 0;',
      }),
    ];
  },
  
  addCommands() {
    return {
      insertDivider: () => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
        });
      },
    };
  },
});
